import Base from './base'

export default {
  get (code) {
    return Base
      .get(`/discountcode/validate/${code}`)
      .then(res => res.data)
  }
}
